import { types as sdkTypes } from '../util/sdkLoader';
import config from '../config';
import { parse } from '../util/urlHelpers';
import { storeData } from './CheckoutPage/CheckoutPageSessionHelpers';
import { setInitialValues as setCheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as loadEditListingPageData } from './EditListingPage/EditListingPage.duck';
import { verify as loadEmailVerificationPageData } from '../ducks/EmailVerification.duck';
import {
  loadData as loadLandingPageData,
  setInitialValues as setLandingPageInitialValues,
} from './LandingPage/LandingPage.duck';
import {
  loadData as loadListingPageData,
  setInitialValues as setListingPageInitialValues,
} from './ListingPage/ListingPage.duck';
import { queryOwnListings } from './ManageListingsPage/ManageListingsPage.duck';
import {
  loadData as loadNewInquiryPageData,
  setInitialValues as setNewInquiryPageInitialValues,
} from './NewInquiryPage/NewInquiryPage.duck';
import { loadData as loadProfilePageData } from './ProfilePage/ProfilePage.duck';
import { searchListings } from './SearchPage/SearchPage.duck';
import {
  loadData as loadTransactionPageData,
  setInitialValues as setTransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

const { UUID } = sdkTypes;

const CHECKOUT_PAGE_STORAGE_KEY = 'CheckoutPage';
const MANAGE_LISTINGS_PAGE_SIZE = 42;
const SEARCH_PAGE_SIZE = 24;

const parseVerificationToken = search => {
  const urlParams = parse(search);
  const verificationToken = urlParams.t;
  return verificationToken ? `${verificationToken}` : null;
};

export const CheckoutPage = {
  setInitialValues: (initialValues, saveToSessionStorage = false) => {
    if (saveToSessionStorage) {
      const { listing, bookingData, bookingDates, includeLodging } = initialValues;
      storeData(
        bookingData,
        bookingDates,
        listing,
        null,
        CHECKOUT_PAGE_STORAGE_KEY,
        includeLodging
      );
    }

    return setCheckoutPageInitialValues(initialValues);
  },
};

export const EditListingPage = {
  loadData: loadEditListingPageData,
};

export const EmailVerificationPage = {
  loadData: (_params, search) => {
    const token = parseVerificationToken(search);
    return loadEmailVerificationPageData(token);
  },
};

export const LandingPage = {
  loadData: loadLandingPageData,
  setInitialValues: setLandingPageInitialValues,
};

export const ListingPage = {
  loadData: loadListingPageData,
  setInitialValues: setListingPageInitialValues,
};

export const ManageListingsPage = {
  loadData: (_params, search) => {
    const queryParams = parse(search);
    const page = queryParams.page || 1;
    return queryOwnListings({
      ...queryParams,
      page,
      perPage: MANAGE_LISTINGS_PAGE_SIZE,
      include: ['images'],
      'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
    });
  },
};

export const NewInquiryPage = {
  loadData: loadNewInquiryPageData,
  setInitialValues: setNewInquiryPageInitialValues,
};

export const ProfilePage = {
  loadData: params => {
    const id = new UUID(params.id);
    return loadProfilePageData(id);
  },
};

export const SearchPage = {
  loadData: (_params, search) => {
    const queryParams = parse(search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });
    const { page = 1, address, origin, ...rest } = queryParams;
    const originMaybe = config.sortSearchByDistance && origin ? { origin } : {};
    return searchListings({
      ...rest,
      ...originMaybe,
      address,
      page,
      perPage: SEARCH_PAGE_SIZE,
      include: ['author', 'images'],
      'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'metadata'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': ['variants.landscape-crop', 'variants.landscape-crop2x'],
    });
  },
};

export const TransactionPage = {
  loadData: loadTransactionPageData,
  setInitialValues: setTransactionPageInitialValues,
};
